export const ul = (listItems: string[]) => {
  return `<ul>${listItems.map((item) => '<li>' + item + '</li>').join('')}</ul>`;
};

export const ol = (listItems: string[]) => {
  return `<ol>${listItems.map((item) => '<li>' + item + '</li>').join('')}</ol>`;
};
